import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useUk } from '../../../../../hooks'
import {
  ProfileUserInfoItem,
  useWidgetContext,
  WidgetContentItemsList,
} from '../../../../Widget'
import {
  getRequestProfileWidgetProvidersRecommendationTooltipKey,
  getRequestProfileWidgetProvidersVisibility,
} from '../RequestProfileWidgetProviders.utils'
import { RequestProfileWidgetProvidersForm } from '../RequestProfileWidgetProvidersForm'
import { RequestProfileWidgetProvidersRecommendedProviderItem } from '../RequestProfileWidgetProvidersRecommendedProviderItem'
import { RequestProfileWidgetProvidersSelectedProvidersAddButton } from '../RequestProfileWidgetProvidersSelectedProvidersAddButton'

import { getProviderItemProps } from './RequestProfileWidgetProvidersContent.utils'

import * as styles from './RequestProfileWidgetProvidersContent.module.css'

function RequestProfileWidgetProvidersContent({
  initialValues,
  modal,
  providers,
  recommendedProviders,
  requestId,
  requestPermissions,
  onClose,
  onSubmit,
}) {
  const { t } = useTranslation()

  const { handleDisableEditMode, handleEnableEditMode, isEditMode } =
    useWidgetContext()

  const [initialRecommendedProviderId, setInitialRecommendedProviderId] =
    useState(null)

  const { config: ukConfig } = useUk()

  const recommendationTooltipKey =
    getRequestProfileWidgetProvidersRecommendationTooltipKey(
      ukConfig?.filters_for_supplier_list_in_request
    )

  function handleAddRecommendedProvider(itemId) {
    setInitialRecommendedProviderId(itemId)
    handleEnableEditMode()
  }

  function handleClose() {
    setInitialRecommendedProviderId(null)
    handleDisableEditMode()
    onClose?.()
  }

  function handleSuccess() {
    setInitialRecommendedProviderId(null)
    handleDisableEditMode()
  }

  const { hasContent, showRecommendedProviders, showSelectedProviders } =
    getRequestProfileWidgetProvidersVisibility({
      recommendedProviders,
      requestPermissions,
    })

  if (isEditMode) {
    return (
      <RequestProfileWidgetProvidersForm
        initialRecommendedProviderId={initialRecommendedProviderId}
        initialValues={initialValues}
        modal={modal}
        recommendationTooltipKey={recommendationTooltipKey}
        recommendedProviders={recommendedProviders}
        requestId={requestId}
        requestPermissions={requestPermissions}
        onClose={handleClose}
        onSubmit={onSubmit}
        onSuccess={handleSuccess}
      />
    )
  }

  return hasContent ? (
    <div className={styles.sections}>
      {showSelectedProviders ? (
        <div className={styles.section}>
          <WidgetContentItemsList
            Item={ProfileUserInfoItem}
            emptyStateAction={
              requestPermissions?.can_edit_contractors ? (
                <RequestProfileWidgetProvidersSelectedProvidersAddButton />
              ) : null
            }
            emptyStateClassName={styles.itemsListEmptyState}
            emptyStateText={t(
              'RequestProfile.ProvidersSelectedProvidersNoDataKey'
            )}
            getItemPropsFromValue={getProviderItemProps}
            items={providers}
            title={t('RequestProfile.ProvidersSelectedProvidersTitleKey', {
              count: providers.length,
            })}
            titleWrapperClassName={styles.itemsListTitleWrapper}
          />
        </div>
      ) : null}
      {showRecommendedProviders ? (
        <div className={styles.section}>
          <WidgetContentItemsList
            Item={RequestProfileWidgetProvidersRecommendedProviderItem}
            info={t(recommendationTooltipKey)}
            itemProps={{
              canAdd: requestPermissions?.can_edit_contractors,
              onAdd: handleAddRecommendedProvider,
            }}
            items={recommendedProviders}
            title={t('RequestProfile.ProvidersRecommendedProvidersTitleKey', {
              count: recommendedProviders.length,
            })}
            titleWrapperClassName={styles.itemsListTitleWrapper}
          />
        </div>
      ) : null}
    </div>
  ) : null
}

export default RequestProfileWidgetProvidersContent
